import videojs from 'video.js';
import './share-button.js';
import './share-settings.js';

const registerPlugin = videojs.registerPlugin || videojs.plugin;

// Default options for the plugin.
const defaults = {};

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 * @param    {Object} [options={}]
 */
const onPlayerReady = (player, options) => {
	let shareButtonComponent;
	player.addClass('vjs-share');
	if (options.add_button_to) {
		setTimeout(() => {
			let component = player.getChild(options.add_button_to) || player;
			shareButtonComponent = component.addChild('shareButton', options);
		});
	} else {
		shareButtonComponent = player.addChild('shareButton', options);
	}
	player.addChild('shareSettings', options);

	if (options.button_text_breakpoint) {
		player.on('playerresize', () => {
			if (!shareButtonComponent) return;
			if (player.currentWidth() <= options.button_text_breakpoint) {
				shareButtonComponent.hideText();
			} else {
				shareButtonComponent.showText();
			}
		});
	}
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function moments
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
const share = function(options) {
	if (!options.soc_url) return;
	this.ready(() => {
		onPlayerReady(this, videojs.mergeOptions(defaults, options));
	});
};

// Register the plugin with video.js.
registerPlugin('share', share);

// Include the version number.
share.VERSION = '__VERSION__';

export default share;
